export default __webpack_public_path__ + "static/media/Griege.285fff81.webp";